var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 0.416656C11.4121 0.416656 14.5834 3.58797 14.5834 7.49999C14.5834 11.412 11.4121 14.5833 7.50008 14.5833C3.58806 14.5833 0.416748 11.412 0.416748 7.49999C0.416748 3.58797 3.58806 0.416656 7.50008 0.416656ZM7.50008 1.47916C4.17487 1.47916 1.47925 4.17478 1.47925 7.49999C1.47925 10.8252 4.17487 13.5208 7.50008 13.5208C10.8253 13.5208 13.5209 10.8252 13.5209 7.49999C13.5209 4.17478 10.8253 1.47916 7.50008 1.47916ZM6.61466 8.51949L9.7807 5.35351C9.98817 5.14604 10.3245 5.14604 10.532 5.35351C10.7206 5.54211 10.7377 5.83725 10.5834 6.04522L10.532 6.10479L6.99029 9.64645C6.80174 9.83508 6.50657 9.85222 6.29861 9.69788L6.23904 9.64645L4.46818 7.87562C4.26072 7.66815 4.26072 7.33183 4.46818 7.12436C4.65679 6.93573 4.95192 6.91859 5.1599 7.07294L5.21948 7.12436L6.61466 8.51949Z",
    fill: "url(#paint0_linear_411_8497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_8497",
    x1: 0.416748,
    y1: 8.38541,
    x2: 14.5834,
    y2: 8.38541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBF2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle_tick.8b515ee7323e04dc633847188706705a.svg";
export { ForwardRef as ReactComponent };